import React from 'react';
import logo from "./assets/images/logo.png";

function App() {
    return (
        <div className="min-vh-100 text-center d-flex align-items-center">
            <div>
                <h1 className="mt-5">Coming Soon!</h1>
                <img src={logo} alt="logo" className="w-50"/>
            </div>
        </div>
    );
}

export default App;
